import { useSearchParams } from "react-router";
import { HokodoSellarCreditTab } from "./HokodoSellarCreditTab/HokodoSellarCreditTab";
import { TwoSellarCreditTab } from "./TwoSellarCreditTab/TwoSellarCreditTab";

export const SellarCreditTab = () => {
  const [searchParams] = useSearchParams();
  const provider = searchParams.get("provider");

  if (provider === "hokodo") {
    return <HokodoSellarCreditTab />;
  }

  return <TwoSellarCreditTab />;
};
